import { Controller } from 'stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = { url: String };

  connect() {
    if (!this.hasUrlValue) return;

    this.sortable = Sortable.create(this.element, {
      animation: 180,
      handle: '.rb-room-card__drag',
      draggable: '.rb-room-card',
      dataIdAttr: 'data-room-id',
      ghostClass: 'is-dragging',
      group: { name: `room-cards-${this.context.scope.id}`, pull: false, put: false },
      emptyInsertThreshold: 0,
      onEnd: (event) => this.handleEnd(event),
    });
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy();
  }

  handleEnd(event) {
    event.item.classList.remove('is-dragging');
    if (event.oldIndex === event.newIndex) return;

    this.persist();
  }

  persist() {
    const ids = this.sortable.toArray().filter(Boolean);
    if (!ids.length) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = new URLSearchParams();
    ids.forEach((id) => body.append('room_ids[]', id));

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    })
      .then((response) => {
        if (!response.ok) {
          window.location.reload();
          return;
        }

        this.updateOrderLabels();
      })
      .catch(() => {
        window.location.reload();
      });
  }

  updateOrderLabels() {
    this.element.querySelectorAll('[data-order-label]').forEach((label, index) => {
      label.textContent = `Order ${index + 1}`;
    });
  }
}
